<template>
  <div class="new-detail">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('工作流程') }}</span>
      <span></span>
    </header>
    <div class="article">
      <div class="title">{{ $t('货物转运流程') }}</div>
      <div class="desc">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item :title="$t('转运须知')" name="1">
            <div v-html="transferNote"></div>
          </van-collapse-item>
          <van-collapse-item :title="$t('违禁品告示')" name="2">
            <van-button
              @click="
                $router.push({
                  name: 'NewsDetail',
                  query: { key: '违禁品告示' },
                })
              "
              type="warning"
              >{{ $t('违禁品告示') }}</van-button
            >
          </van-collapse-item>
        </van-collapse>
        <div class="sec-title">{{ $t('简单四步，开始您的集运') }}</div>
        <van-steps :active="active" direction="vertical">
          <van-step>
            <div class="step-text">1 {{ $t('发货到集货仓') }}</div>
          </van-step>
          <van-step>
            <div class="step-text">2 {{ $t('货物预报') }}</div>
          </van-step>
          <van-step>
            <div class="step-text">3 {{ $t('集包发货') }}</div>
          </van-step>
          <van-step>
            <div class="step-text">4 {{ $t('目的地收货') }}</div>
          </van-step>
        </van-steps>
        <van-grid class="text-center" clickable>
          <van-grid-item
            icon="wap-home"
            @click="$router.push({ name: 'RecStorageAddr' })"
            :text="$t('购物，发货到集运仓库')"
          />
          <van-grid-item
            icon="todo-list"
            @click="$router.push({ name: 'EnterPackage' })"
            :text="$t('预报货物，开始转运')"
          />
          <van-grid-item
            icon="point-gift"
            @click="$router.push({ name: 'Deliver' })"
            :text="$t('申请集包，支付订单发货')"
          />
          <van-grid-item
            icon="bill"
            @click="$router.push({ name: 'Orders' })"
            :text="$t('货物到目的地后，签收')"
          />
        </van-grid>
      </div>

      <div class="content">
        <div class="sec-title">{{ $t('货物详细转运流程') }}</div>
        <div class="steps-timeline">
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">
              {{ $t('您的货物打包发到我们集运仓库') }}
            </div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">
              {{ $t('根据您的指令我们打包测量装柜') }}
            </div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">{{ $t('办理国内货物报关手续') }}</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">{{ $t('装船/装机运输至目的地') }}</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">{{ $t('目的地国家港口海关清关') }}</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">
              {{ $t('货物送达监管仓库（支持自提或配送）') }}
            </div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">{{ $t('完成送货上门签收') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASE_URL } from '@/api/index.js';
import { getFirmInfo, getWebConf, getOrgInfoByUrl } from '@/api/website.js';
import Vue from 'vue';
import { Collapse, CollapseItem } from 'vant';
import { Step, Steps } from 'vant';

Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.use(Step);
Vue.use(Steps);
// import { formatDate } from '@/utils/index.js';
// function getValidTime(value) {
//   if (value == null || value == '') return '';
//   var myDate = new Date(value.match(/\d+/)[0] * 1);
//   return formatDate(myDate);
// }
export default {
  data() {
    return {
      CompanyName: '',
      CompanyObligation: '',
      activeName: 1,
      active: 4,
      transferNote: '',
      orgInfo: null,
    };
  },
  async mounted() {
    let jsInfo = localStorage.getItem('ORG_INFO');
    if (jsInfo != null) {
      this.orgInfo = JSON.parse(jsInfo);
    } else {
      await getOrgInfoByUrl(window.location.href).then(res => {
        console.log(res);
        if (res.Result == true) {
          this.orgInfo = res.DataDict['org'];
          localStorage.setItem('ORG_INFO', JSON.stringify(this.orgInfo));
        }
      });
    }
    if (this.orgInfo == null) {
      this.orgInfo = {
        PK_ID: 1,
      };
    }

    this.loadData();
  },
  computed: {},
  methods: {
    htmlDecode(text) {
      //1.首先动态创建一个容器标签元素，如DIV
      var temp = document.createElement('div');
      //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
      temp.innerHTML = text;
      //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
      var output = temp.innerText || temp.textContent;
      temp = null;
      console.log(output);
      return output;
    },
    loadData() {
      getFirmInfo().then(res => {
        if (res.Result == true) {
          let data = res.DataDict['data'];
          console.log(res);
          this.CompanyName = data.CompanyName;
          this.CompanyObligation = data.CompanyObligation;
          this.CompanyPhone = data.CompanyPhone;
          if (data.CompanyPresentationImg.startsWith('http')) {
            this.CompanyPresentationImg = data.CompanyPresentationImg;
          } else {
            this.CompanyPresentationImg =
              BASE_URL + data.CompanyPresentationImg;
          }
          this.CompanyQQ = data.CompanyQQ;
          this.CompanyResume = data.CompanyResume;
          this.CompanySummary = data.CompanySummary;
          this.CompanyTel = data.CompanyTel;
          this.CompanyVision = data.CompanyVision;
          this.CompanyWechat = data.CompanyWechat;
          if (data.WechatPicUrl.startsWith('http')) {
            this.WechatPicUrl = data.WechatPicUrl;
          } else {
            this.WechatPicUrl = BASE_URL + data.WechatPicUrl;
          }
          this.CompanyMission = data.CompanyMission;
          this.CompanyMail = data.CompanyMail;
          this.CompanyLinkMan = data.CompanyLinkMan;
          this.CompanyAddr = data.CompanyAddr;
        }
      });

      getWebConf(this.orgInfo.PK_ID, 'OMS_COMPANY_TRANSFER_NOTE').then(res => {
        if (res.Result == true) {
          this.transferNote = this.htmlDecode(res.DataDict['data'].sContent); 
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_var';

.article {
  margin: rem(20px);
  margin-top: rem(100px);
  line-height: 0.6rem;
  background: #fff;
  max-width: 100%;
  padding: rem(20px);

  .title {
    font-size: rem(40px);
    text-align: left;
    padding: rem(15px);
  }

  .img img {
    width: 100%;
    height: rem(260px);
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .content {
    img {
      max-width: 100%;
    }
  }

  .author {
    font-size: rem(18px);
    padding: rem(15px);
  }

  img {
    max-width: 100%;
  }

  .text-center {
    text-align: center;
  }

  .btn-primary {
    color: #2196f3;
  }

  .sec-title {
    font-family: PingFang-SC-Medium;
    font-size: 16px;
    color: #3a3a3a;
    letter-spacing: 0;
    padding: 0px;
    border-left: solid #484744 9px;
    padding-left: 15px;
    margin-left: 12px;
  }

  .steps-timeline {
    position: relative;
    max-width: 800px;
    margin: 10px auto;
    padding-left: 30px;
    counter-reset: step;
  }

  .steps-timeline:before {
    content: '';
    position: absolute;
    left: 12px;
    top: 0;
    height: 100%;
    width: 2px;
    background: #e0e0e0;
  }

  .step-item {
    position: relative;
    margin-bottom: 30px;
    padding-left: 40px;
  }

  .step-item:last-child {
    margin-bottom: 0;
  }

  .step-number {
    position: absolute;
    left: 0;
    top: 0;
    width: 26px;
    height: 26px;
    background: #2196f3;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    counter-increment: step;
  }

  .step-number:before {
    content: counter(step);
  }

  .step-content {
    background: #f5f5f5;
    padding: 15px 20px;
    border-radius: 8px;
    line-height: 1.6;
    position: relative;
  }

  .step-content:before {
    content: '';
    position: absolute;
    left: -10px;
    top: 12px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #f5f5f5;
  }

  .step-text {
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
    line-height: 15px;
    // width: 88px;
  }
  ::v-deep .van-step--horizontal .van-step__title {
    font-size: 10px !important;
  }

  ::v-deep .van-step--horizontal:nth-child(2) .van-step__title {
    transform: translateX(-30%) !important;
    -webkit-transform: translateX(-30%) !important;
  }
  ::v-deep .van-step--horizontal:nth-child(3) .van-step__title {
    transform: translateX(-60%) !important;
    -webkit-transform: translateX(-60%) !important;
  }
  ::v-deep .van-step--horizontal:nth-child(4) .van-step__title {
    transform: translateX(20%) !important;
    -webkit-transform: translateX(20%) !important;
  }
}
</style>
